import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-api-error-dialog-template',
  templateUrl: './api-error-dialog-template.component.html',
  styleUrls: ['./api-error-dialog-template.component.scss']
})
export class ApiErrorDialogTemplateComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
